function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVivaEngage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "vivaEngage_svg__a",
  x1: 6,
  x2: 13.046,
  y1: 31.333,
  y2: -2.057,
  gradientTransform: "scale(.375)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#053377",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#2f91f2",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "vivaEngage_svg__b",
  x1: 53.361,
  x2: 37.333,
  y1: 4.955,
  y2: 29,
  gradientTransform: "scale(.375)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#4ac1ff",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  style: {
    stopColor: "#155eb5",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "vivaEngage_svg__c",
  x1: 27.667,
  x2: 43.333,
  y1: 14.333,
  y2: 45.333,
  gradientTransform: "scale(.375)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#96dfff",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.413,
  style: {
    stopColor: "#53adee",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#006bb9",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "vivaEngage_svg__d",
  x1: 40.226,
  x2: 57.12,
  y1: 38.85,
  y2: 66.945,
  gradientTransform: "scale(.375)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  style: {
    stopColor: "#4ac1ff",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#155eb5",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "vivaEngage_svg__e",
  x1: 6.642,
  x2: 22.512,
  y1: 27.769,
  y2: 65.961,
  gradientTransform: "scale(.375)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#2f91f2",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#053377",
    stopOpacity: 1
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "M6 0c3.313 0 6 2.688 6 6v7.5H0V6c0-3.312 2.688-6 6-6m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#vivaEngage_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0c-3.312 0-6 2.688-6 6v7.5h12V6c0-3.312-2.687-6-6-6m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#vivaEngage_svg__b)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 9.75c0-3.312-2.687-6-6-6-3.312 0-6 2.688-6 6 0 3.313 2.688 6 6 6 3.313 0 6-2.687 6-6m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#vivaEngage_svg__c)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 6v-.117h-.004c-.148 3.496-3.246 6.312-7.121 6.484v.008c-3.312 0-6 2.602-6 5.813s2.688 5.812 6 5.812h.035c5.969-.023 7.09-5.895 7.09-8.625Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#vivaEngage_svg__d)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 15.375c0 2.73 1.121 8.602 7.09 8.625h.035c3.313 0 6-2.602 6-5.812s-2.687-5.813-6-5.813v-.008C3.25 12.195.152 9.38.004 5.883H0V6Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#vivaEngage_svg__e)"
  }
}));
export { SvgVivaEngage as ReactComponent };
export default __webpack_public_path__ + "static/media/vivaEngage.65f8d742.svg";